import React, { useMemo, useState } from 'react';
import './UserAvatar.css';

const roleLabels = {
  admin: 'Admin',
  manager: 'Manager',
  instructor: 'Instructeur',
  student: 'Student'
};

const getInitials = (user) => {
  const first = String(user?.firstName || '').trim().charAt(0).toUpperCase();
  const last = String(user?.lastName || '').trim().charAt(0).toUpperCase();
  const initials = `${first}${last}`.trim();

  if (initials) return initials;

  const fullName = String(user?.fullName || user?.name || '').trim();
  if (!fullName) return 'NL';

  return fullName
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
};

const UserAvatar = ({ user, size = 'md', className = '' }) => {
  const [hasImageError, setHasImageError] = useState(false);
  const initials = useMemo(() => getInitials(user), [user]);
  const roleClass = `role-${String(user?.role || 'user').toLowerCase()}`;
  const imageUrl = user?.profilePhotoUrl && !hasImageError ? user.profilePhotoUrl : '';

  return (
    <div
      className={`user-avatar-chip ${size} ${roleClass} ${className}`.trim()}
      title={`${roleLabels[user?.role] || 'Gebruiker'}: ${user?.fullName || user?.name || ''}`.trim()}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={user?.fullName || user?.name || 'Gebruiker'}
          className="user-avatar-image"
          onError={() => setHasImageError(true)}
        />
      ) : (
        <span className="user-avatar-initials">{initials}</span>
      )}
    </div>
  );
};

export default UserAvatar;
